import {pageInfo, getOptionalPurchOrderNo,savePurchOrderSwitch,editPurchOrderSwitch} from '../api';
import {Message} from 'element-ui';

const purchOrderSwitch = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    optionalPurchOrderNoObj: null,
    optionalPurchOrderNoTotal: 0,
    savePurchOrderSwitchObj: null,
    editPurchOrderSwitchObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    GET_OPTIONAL_PURCH_ORDER_NO(state, data) {
      state.optionalPurchOrderNoObj = data;
      state.optionalPurchOrderNoTotal = data.total;
    },
    SAVE_PURCH_ORDER_SWITCH(state, data) {
      state.savePurchOrderSwitchObj = data;
    },
    EDIT_PURCH_ORDER_SWITCH(state, data) {
      state.editPurchOrderSwitchObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async getOptionalPurchOrderNo({commit}, obj){
      let result = await getOptionalPurchOrderNo(obj);
      commit('GET_OPTIONAL_PURCH_ORDER_NO', result);
    },
    async savePurchOrderSwitch({commit}, obj){
      let result = await savePurchOrderSwitch(obj);
      commit('SAVE_PURCH_ORDER_SWITCH', result);
    },
    async editPurchOrderSwitch({commit}, obj){
      let result = await editPurchOrderSwitch(obj);
      commit('EDIT_PURCH_ORDER_SWITCH', result);
    }
  }
}
export default purchOrderSwitch



// WEBPACK FOOTER //
// ./src/page/bd/order/purchOrderSwitch/store/purchOrderSwitch.store.js